import { logEvent } from "firebase/analytics"; // Import logEvent from firebase/analytics
import { analytics } from "../firebase"; // Import the analytics instance

/**
 * Asynchronous function to handle user sign-up, including Firebase Analytics conversion tracking.
 * @param {object} userData - The user data for registration (e.g., mobile, pincode).
 * @returns {Promise<boolean>} - True if registration is successful, false otherwise.
 */
const handleSignUp = async (userData) => {
  try {
    // Placeholder for actual user registration logic.
    // In a real application, this would involve calling a Firebase Auth method
    // or an API endpoint to register the user.
    console.log("Attempting to register user:", userData);
    // Simulate a successful registration
    const registrationSuccess = true;

    if (registrationSuccess) {
      // Retrieve UTM parameters from sessionStorage
      const utmSource = sessionStorage.getItem("utm_source") || "direct";
      const utmMedium = sessionStorage.getItem("utm_medium") || "none";
      const utmCampaign = sessionStorage.getItem("utm_campaign") || "none";

      // Log a custom sign_up event to Firebase Analytics with UTM parameters
      logEvent(analytics, "sign_up", {
        source: utmSource,
        medium: utmMedium,
        campaign: utmCampaign,
        mobile: userData.mobile, // Include the user's mobile number
        pincode: userData.pincode, // Include the user's pincode
      });

      console.log(
        "User registered successfully and sign_up event logged to Firebase Analytics.",
      );
      return true;
    }
    return false;
  } catch (error) {
    console.error("Sign-up failed:", error);
    // Optionally log error to Firebase Analytics or another error tracking service
    return false;
  }
};

export default handleSignUp;
